import {
    PADS,
    KEYBOARD,
    CONTROLCHANGE_SUSTAIN,
    CONTROLCHANGE_PLAY, CONTROLCHANGE_STOP,
    CONTROLCHANGE_RECORD, CONTROLCHANGE_NEXT,
    CONTROLCHANGE_PREVIOUS,
    CONTROLCHANGE_MODULATION,
} from './constants.js';

export default superclass => class extends superclass  {

    onControlChange(midiCC, slider, e) {
        midiCC.onEvent(e);
        if (slider) {
            slider.onEvent(e.controller.number, e.value);
        }
        if (e.controller.number === CONTROLCHANGE_PLAY) {
            this.sequencerEngine.play();
        } else if (e.controller.number === CONTROLCHANGE_STOP) {
            this.sequencerEngine.stop();
        } else if (e.controller.number === CONTROLCHANGE_RECORD) {
            let state = this.sequencerEngine.store.getState();
            this.sequencerEngine.recording(!state.sequencer.isRecording);
        } else if (e.controller.number === CONTROLCHANGE_NEXT) {
            this.sequencerEngine.switchToNextPattern();
        } else if (e.controller.number === CONTROLCHANGE_PREVIOUS) {
            this.sequencerEngine.switchToPreviousPattern();
        } else if (e.controller.number === CONTROLCHANGE_SUSTAIN) {
            this.sequencerEngine.sustain(e.value);
        } else if (e.controller.number === CONTROLCHANGE_MODULATION) {
            this.onModulationChange(e.value);
        }
        
        if (e.controller.number >= 1 && e.controller.number <= 6) {
            let group = this.sequencerEngine.groups.groups[e.controller.number - 1];
            if (group !== undefined) {
                if (group.tracks.length == 1) {
                    // group.tracks[0].setVolume(e.value);
                } else {
                    // group.setVolume(e.value);
                }
            }
        } else {
            this.onControllerAux(e);
        }
    }

    onPitchBend(e) {
        let track = this.sequencerEngine.getSelectedTrack();
        if (track.instrument) {
            if (track.instrument.onPitchBend) {
                track.instrument.onPitchBend(e.value);
            }
        }
    }

    onModulationChange(value) {
        let track = this.sequencerEngine.getSelectedTrack;
    }
}
